import type {
  CreateUpdatePeopleRequestDto,
  GetPeopleResponseDto,
  PeopleDto,
  RemovePeopleResponseDto,
} from 'shared/dtos/people.dto';

import { createAsyncThunk } from '@reduxjs/toolkit';
import PeopleService from 'services/people.service';

const peopleService = new PeopleService();

export const getPeopleThunk = createAsyncThunk<GetPeopleResponseDto>(
  'people/getPeople',
  async (_, thunkAPI) => {
    try {
      return await peopleService.getPeople();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const removePeopleThunk = createAsyncThunk<
  RemovePeopleResponseDto,
  number
>('people/removePeople', async (id, thunkAPI) => {
  try {
    const result = await peopleService.removePeople(id);
    thunkAPI.dispatch(getPeopleThunk());
    return result;
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const createPeopleThunk = createAsyncThunk<
  PeopleDto,
  CreateUpdatePeopleRequestDto
>('people/createPeople', async (data, thunkAPI) => {
  try {
    const result = await peopleService.createPeople(data);
    thunkAPI.dispatch(getPeopleThunk());
    return result;
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const updatePeopleThunk = createAsyncThunk<
  PeopleDto,
  CreateUpdatePeopleRequestDto & { id: number }
>('people/updatePeople', async (payload, thunkAPI) => {
  try {
    const { id, ...data } = payload;
    const result = await peopleService.updatePeople(id, data);
    thunkAPI.dispatch(getPeopleThunk());
    return result;
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const getPersonThunk = createAsyncThunk<PeopleDto, number>(
  'people/getPerson',
  async (id, thunkAPI) => {
    try {
      const result = await peopleService.getPerson(id);
      return result;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);
